// extracted by mini-css-extract-plugin
module.exports = {"letter":"LetterPicker_letter__LW9xM"};